export default {
  lang: 'Spanish',
  homeScreen: {
    title: 'POTENCIA TUS SUEÑOS',
    stayConnected: 'Mantente conectado:',
    download: 'Descargar ahora',
  },
  notification: {
    newAndNow: '¡Novedades!',
    alert: 'Alerta',
    message: 'Mensaje',
    contest: 'Concurso',
    badge: 'Insignia Nueva',
    'content-update': 'Actualización de Contenido',
    events: 'Eventos',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Vamos a ver si podemos encontrar un perfil existente para usted en nuestro sistema.',
      homeTitleSub:
        'Introduzca la dirección de correo electrónico que utiliza habitualmente para acceder a los programas de formaci',
      noAccount:
        'No se ha encontrado ninguna cuenta ({email}), inténtalo con otra dirección de correo electrónico o crea una cuenta ahora.',
      continueButton: 'Continuar',
      success:
        'Ha actualizado correctamente su cuenta. En breve será redirigido a la página de inicio.',
      successNewAccount:
        'Para completar su inscripción, recibirá un correo electrónico de confirmación para verificar su cuenta.',
      loginButton: 'Inicio de sesión',
      matchFound:
        'Hemos encontrado una coincidencia, por favor, introduzca su contraseña para continuar.',
      magicLink:
        'Inicie sesión a través de un enlace en su correo electrónico:',
      magicLinkButton: 'Solicitar Magic Link',
      magicLinkTitle:
        'Recibe un enlace directo en tu correo electrónico que te permitirá registrarte al instante.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      titleIndustry:
        'Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.',
      register: 'Crear una cuenta',
      agent: 'Asesor de viajes',
      visitor: 'Visitante del sector',
      step1: 'Paso 1: Tipo de usuario',
      step2: 'Paso 2: Crear una cuenta',
      step3: 'Paso 3: Cree su perfil',
      marketingOptIn:
        '¿Está seguro de que no le interesa seguir vinculado al equipo de comercio de viajes de este programa?',
      optIn: 'Sí, me interesa',
      optOut: 'No me interesa',
      step2Sub1: 'Háblenos de usted',
      step2Sub2: 'Háblenos de su empresa',
      privacyHead: 'PREFERENCIAS DE COMUNICACIÓN',
      privacySub:
        'Marque las casillas que aparecen a continuación para asegurarse de que recibe comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de redes comerciales de viajes y apoyo a las ventas de TravPRO Mobile.',
      privacy:
        'Protegemos su privacidad y nunca vendemos, abusamos o traicionamos su confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'PODER DE',
      toastMessage: {
        forgotSuccess:
          'Le hemos enviado por correo electrónico un enlace para restablecer su contraseña. Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting:
          'La dirección de correo electrónico que has introducido no existe.',
        magicLinkMessage:
          'Por favor, espera, te estamos registrando ahora mismo.',
        magicLinkError:
          'No hemos podido encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkError1:
          'No hemos podido encontrar un token válido, por favor inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, póngase en contacto con nosotros en: info@travpromobile.com.',
        magicLinkError2:
          'No hemos podido encontrar su cuenta en nuestra base de datos, por favor inicie sesión manualmente. Será redirigido en 10 segundos.',
        magicLinkSuccess:
          'Comprueba tu correo electrónico en {email}. Tiene un enlace mágico que te registrará.',
        magicLinkErrorWait:
          'Por favor, espera 5 minutos entre peticiones de enlace mágico.',
        emailNotFoundError:
          'La dirección de correo electrónico que ha introducido no se encuentra en nuestros registros. Por favor, compruebe si hay errores ortográficos o cree una cuenta.',
      },
      errors: {
        zipCodeNotFound: 'Código postal no encontrado, inténtelo de nuevo',
        zipCodeOnlyNumbers: 'El código postal sólo puede contener números',
        password: 'Introduzca una contraseña',
        passwordNotMatching: 'Las contraseñas introducidas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        emailExists:
          'Esta dirección de correo electrónico ya existe o no es válida. Inténtelo con otra dirección de correo electrónico o acceda a su cuenta.',
        fillInAllFields: 'Rellene todos los campos obligatorios',
        fillInEmail:
          'Por favor, introduzca su dirección de correo electrónico.',
        emailNotExisting:
          'La dirección de correo electrónico que ha introducido no existe.',
      },
      fields: {
        forgotSubCopy: '¿Has olvidado tu contraseña y quieres cambiarla? ',
        forgotSubCopy2:
          '¿Quiere saltarse la contraseña por completo? Le enviaremos un correo electrónico con un enlace mágico que le permitirá acceder automáticamente al programa. ',
        city: 'Ciudad',
        companyName: 'Nombre de la empresa',
        role: 'Su función',
        description: '¿Cuál describe mejor la actividad de su empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elija una contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar contraseña',
        firstName: 'Nombre',
        lastName: 'Apellido (Familia)',
        agency: 'Nombre de su agencia',
        title: 'Su función (seleccione una)',
        company: 'Nombre de la empresa',
        select: 'Seleccione una opción',
        state: 'Estado',
        province: 'Provincia/Región/Estado',
        zipCode: 'Código postal',
        postalCode: 'Código postal',
        affiliate: '¿A qué grupo está afiliada su agencia PRINCIPAL?',
        hostAgency: '¿Su agencia de acogida?',
        executive: 'Ejecutivo',
        management: 'Gestión',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        opt: 'Manténgase en contacto con el equipo de comercio de viajes de este programa y reciba actualizaciones.',
        optMarketing:
          'Manténgase en contacto con TravPRO en relación con programas y eventos similares.',
        retail: 'Fachada de tienda',
        home: 'Agente a domicilio',
        independent: 'Contratista independiente',
        host: 'Organismo anfitrión',
        call: 'Centro de llamadas o agencia web',
        other: 'Otros',
        describes:
          '¿Qué es lo que mejor describe su actividad y la de su agencia?',
      },
    },
    title: 'Programa de capacitación para profesionales del turismo y ventas',
    welcome: {
      headerTop: 'Bienvenido(a) a la página de tu',
      headerBottom: 'Socio de Ventas, Visit California STAR. ',
    },
    sellingPoints: [
      'Herramientas de apoyo para ventas',
      'Valiosa informacíon y presentaciones de gran calidad',
      'Personalízala con la carpeta "favoritos”',
      'En línea, sin conexión, en cualquier momento y en cualquier lugar',
      'Comparte, conecta y transforma',
    ],
    emailPrompt:
      'Por favor, ingresa tu dirección de correo electrónico para confirmar que eres un profesional del turismo.',
    tAndC: {
      agree: 'Al continuar, estás de acuerdo con nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y nuestros ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      agency: 'Agencia',
      email: 'Correo electrónico',
      firstName: 'Nombre ',
      lastName: 'Apellido',
      agencyName: 'Nombre de la agencia',
      stateProvince: 'Estado / Provincia',
      registrationCode: 'Código promocional (Opcional)',
      required: 'Necesario',
      invalidEmail: 'Dirección de correo electrónico inválida',
      opt: '¡Mantente en contacto! ¡Sí, me gustaría participar en las comunicaciones de Visit California que me mantendrán informado sobre noticias, eventos, incentivos, FAM y más!',
      forgot:
        '¿Ha olvidado su contraseña? Haz clic en el botón de abajo y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    forgot: 'Restablecer contraseña',
    noAgent: {
      noAgentButton: 'No soy asesor',
      title: 'Gracias por interesarte en California STAR.',
      messageWeb:
        'El contenido de este sitio es exclusivamente para profesionales del turismo. \n Para obtener más información sobre California STAR, por favor visita: ',
      messageMobile:
        'Parte del contenido de esta aplicación es exclusivo para profesionales del turismo, pero no dudes en echar un vistazo a lo que te ofrece esta aplicación presionando “Continuar”.',
      continue: 'Continuar',
      visitWebsite: 'Visita la página web >',
    },
    newUser: 'Nuevo usuario',
    register: 'Registrarse',
  },
  welcomeScreen: {
    title:
      'Bienvenido(a) al\nPrograma de Capacitación y Socio de Ventas de STAR de California',
    helloUser: 'Hola {name}',
    hello: 'Hola,',
    fromAgency: 'de {agency}',
    notUser: '¿No eres {name}?',
    introOnline:
      '¡Practica inmediatamente en línea o precarga el contenido para que esté siempre disponible para su uso sin conexión!',
    introOffline:
      'Ya tienes la última versión precargada. ¡Comienza a practicar o a vender en cualquier momento y en cualquier lugar!',
    startTraining: 'Comenzar a practicar',
    downloader: {
      preload: 'Precarga',
      stop: 'parar',
      init: 'Iniciando…',
      lastUpdate: 'Última actualización: ',
    },
  },
  trainingScreens: {
    review: 'Revisar',
    start: 'Empezar',
    continue: 'Continuar',
    welcome:
      'Bienvenido a nuestra sección de formación rediseñada. ¡Simplemente complete los módulos para ganar puntos hacia su objetivo final de convertirse en Gold CA STAR! ¡La barra de la derecha el progreso de su entrenamiento!',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number} % completado',
    unlock:
      'Desbloquea este capítulo completando el capítulo {number} de la capacitación.',
    unlockSpecialization:
      'Desbloquea este capítulo completando Los Fundamentos',
    unlockSubtitle:
      'Desbloquea más capítulos completando más capítulos de la capacitación.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    courseComplete: '¡Curso completo!',
    chapterComplete: 'Chapter complete!',
    message: '{count} Mensaje de STAR',
    messagePlural: '{count} Mensajes de STAR',
    endReached: 'Has llegado al final',
    retainEnd:
      'Usa la barra superior para navegar por este capítulo o pulsa el botón atrás para volver a la vista general.',
    watchListenRead: 'Ver, escuchar y leer más',
    trouble:
      'Parece que tienes problemas, ¿te gustaría saltarte esta pregunta?',
    confirm: 'Confirma tu respuesta',
    choose: 'Por favor, elige una respuesta',
    chapter: 'Capítulo',
    essential: 'Módulos esenciales',
    essentialSub:
      'Complete estos módulos para ganar la categoría CA STAR Bronce',
    specialization: 'Módulos de especialización',
    specializationSub:
      'Complete estos módulos para ganar la categoría CA STAR Plata',
    status: 'Categoría actual',
  },
  nav: {
    home: 'Inicio',
    train: 'Formar',
    retain: 'Retener',
    directory: 'Directorio',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Información',
    media: 'Multimedia',
    favorites: 'Favoritos',
    contact: 'Contacto',
    reportCard: 'Calificaciones',
    accountSettings: 'Configuración de la cuenta',
    messages: 'Mensaje de STAR',
    search: 'Buscar',
    showcases: 'Escaparates',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Biblioteca de capacitación',
    retain: 'Referencia',
    subapps: 'Mini capacitación para socios de California',
    maintrainings: 'La Fundación',
    subtrainings: 'La experiencia',
  },
  pageDescriptions: {
    train: 'Eduque, comprométase y conviértase en un experto.',
    retain:
      'Esta herramienta de referencia ayuda a reforzar sus conocimientos y habilidades de ventas del destino. Utilice esta área para responder de manera experta a una pregunta sobre un producto o incluso como una presentación de ventas improvisada, en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    promote:
      'Fácil acceso a la garantía de ventas compartidas y a la sección de contacto.',
    sell: 'Todos los recursos multimedia y material de ventas están organizados para facilitar el acceso y su difusión',
    favorites: 'Echa un vistazo a tu contenido personal favorito',
    search: 'Busca en todo el contenido',
    subapps: 'Aprenda más de nuestros socios',
    maintrainings:
      '¡Completa estos capítulos esenciales para obtener tu diploma!',
    subtrainings:
      'Gana una insignia completando cada experiencia especializada a continuación.',
  },
  general: {
    showcase: 'Showcases',
    next: 'Siguiente',
    previous: 'Anterior',
    submit: 'Enviar',
    showcase: 'Descubre',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver',
    imageNotFound: 'Imagen no encontrada',
    noResultsFor: 'No se han encontrado resultados para: {query}',
    noFavorites: 'Aún no tienes ningún favorito.',
    noMessages: '¡Todavía no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {query}',
    showAll: 'Mostrar todos',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡404 Página no encontrada!',
    oops: 'Uh oh…',
    overview: 'Volver a la vista general',
    complete: '¡Curso terminado!',
    share: 'Compartir',
    destinations: 'Mini capacitación para socios de California',
    essentials: 'Lo esencial de California',
    trainingLibrary: 'Biblioteca de capacitación',
    message: '{count} Mensaje de STAR',
    messagePlural: '{count} Mensajes de STAR',
    badge: 'Insignia',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Compilación',
    layout: 'Esquema',
    web: 'Página web',
    pdf: 'PDF',
    carousel: 'Compilación',
  },
  questions: {
    dials: 'Gira los discos para que coincidan con la respuesta',
    fitb: 'Llena los espacios en blanco',
    flip: 'Cambia el número para que coincida con la respuesta',
    multipleChoice: 'Elige la(s) respuesta(s) correcta(s)',
    slider: 'Elige la respuesta correcta usando el control deslizante',
    map: 'Contesta la pregunta tocando el lugar correcto en el mapa',
    dropdown: 'Selecciona…',
    true: 'Verdadero',
    false: 'Falso',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Darse de baja',
    settings: 'Ajustes de privacidad',
    message:
      '¡No nos has contado nada sobre tus preferencias de confidencialidad de datos! No hay problema, pero nos gustaría ofrecerte la mejor experiencia utilizando la característica Socio de Ventas.',
    disabled: 'Parece que deshabilitaste el uso de cookies.',
    use: 'El {appName} necesita el uso de cookies para darte la mejor experiencia.',
    details: '¿Para qué se utilizan las cookies?',
    enable: 'Mira cómo habilitar tus cookies {here}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Necesitas iniciar sesión para ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message:
      'Esta página es una versión de muestra del producto final. Actualmente está en desarrollo y no es un producto terminado.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este material en tus redes sociales favoritas!',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header:
      'Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visita la tienda de aplicaciones y busca {appName} o haz clic en uno de los siguientes botones',
    benefits: {
      header: 'Esto te dará:',
      1: 'Portabilidad',
      2: 'No hay necesidad de Wifi, practica cuando y donde creas apropiado.',
      3: 'Herramientas y recursos de ventas en la palma de tus manos',
    },
  },
  sharing: {
    twitter: 'Contempla pasar tus próximas vacaciones en California…',
    imageEmailSubject:
      'Sólo para ti, de parte de California STAR… Ideas para las vacaciones',
    imageEmailCopy:
      'Tomate un minuto para revisar el contenido adjunto acerca de las vacaciones de California STAR... ¡Disfrútalo!',
    videoEmailSubject:
      '¡Compartimos contigo ideas geniales para las vacaciones de California STAR!',
    videoEmailCopy:
      'Pensé que disfrutarías de este video acerca de las vacaciones de California STAR. Simplemente haz clic en el enlace de abajo para verlo.  ¡Que lo disfrutes!',
    infographicEmailSubject:
      'Compartimos algunas ideas acerca de las vacaciones de California STAR…',
    infographicEmailCopy:
      'Creemos que esto te interesaría, tómate un minuto para ver el contenido adjunto.   ¡Nos estamos hablando!',
    copyURL: 'Copiar link',
    copied: 'Copiado',
  },
  newTrainingFlow: {
    tip: 'Gane su categoría al completar los módulos dentro de cada nivel.  ¡Sueñe en grande y alcance la categoría CA STAR Oro completando todos los módulos!',
    essentialModules: 'Módulos esenciales',
    finishBronze:
      'Complete estos módulos para ganar la categoría CA STAR Bronce',
    specializationModules: 'Módulos de especialización',
    finishSilver:
      'Complete estos módulos para ganar la categoría CA STAR Plata',
    partnerModules: 'Módulos de asociados',
    finishGold: 'Complete estos módulos para ganar la categoría CA STAR Oro',
    currentStatus: 'Categoría actual',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'para alcanzar la clasificación {rank}!',
    outOf: '{points} XP de',
    pointsToRank:
      '{pointsToLevel} XP necesarios para la clasificación:  ({rank})',
  },
  points: {
    completed: '{completed} / {total} completado',
  },
  new: {
    achievements: 'Logros',
  },
  badgeView: {
    title: 'Logros de formación',
    subtitle:
      'Bienvenido a tu panel de Logros, donde puedes ver, seguir y descargar tus insignias de diploma y especialización.',
    badgeDisplayTitle: 'Estado de logro metálico',
    badgeAchievement:
      '¡Has alcanzado el estado {rank}! Haz clic en el icono de la derecha para ver y compartir tu estado.',
    bronze: 'Bronce',
    silver: 'Plata',
    gold: 'Oro',
    platinum: 'Platino',
    complete: 'COMPLETO',
    diploma: 'Diploma',
    chapterBadges: 'Insignias de especialización',
    partnerBadges: 'Insignias de Socio',
  },
  badgeDisplay: {
    status: 'Nivel de formación alcanzado',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
